import React from "react";
import { 
  ActionButtonsContainer, 
  EditButtonCell, 
  EditButton, 
  ActionButton 
} from "../Returns.styled";
import styled from "styled-components";

// New styled component for the Submit button with amber styling
const SubmitButton = styled.button`
  padding: 4px 8px;
  font-size: 13px;
  border-radius: 4px;
  cursor: pointer;
  width: 80px;
  border: 1px solid #383c41;
  background-color: rgba(251, 207, 9, 1); /* Amber background */
  color: black; /* Black text */
  
  &:hover {
    background-color: rgba(251, 207, 9, 0.9); /* Slightly dimmed on hover */
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

interface ActionButtonsProps {
  auctionId: string;
  isEditing: boolean;
  isDisabled: boolean;
  exceedsCapacity: boolean;
  onSave: () => void;
  onCancel: () => void;
  onStartEdit: () => void;
  onSubmit?: () => void;
  hasQuantity: boolean;
  canSubmit: boolean;
  inputRef: React.RefObject<HTMLInputElement | null>;
  maxCapacity: number;
}

/**
 * Component that renders either edit button or accept/cancel buttons
 * depending on whether the row is in edit mode
 */
export const ReturnActionButtons: React.FC<ActionButtonsProps> = ({
  isEditing,
  isDisabled,
  exceedsCapacity,
  onSave,
  onCancel,
  onStartEdit,
  onSubmit,
  hasQuantity,
  canSubmit,
  inputRef,
  maxCapacity
}) => {
  if (isEditing) {
    // Show accept/cancel buttons when in edit mode
    return (
      <ActionButtonsContainer>
        <ActionButton
          color="green"
          title="Accept"
          onClick={() => {
            // Get the current value from the input field
            if (inputRef.current) {
              const value = inputRef.current.value;
              const numValue = parseFloat(value);
              const exceeds = value && numValue > maxCapacity;
              const isZeroOrNegative = value && numValue <= 0;

              if (value && value.trim() !== "" && !exceeds && !isZeroOrNegative) {
                onSave();
              } else if (exceeds || isZeroOrNegative) {
                // Just maintain edit mode and show validation
              } else {
                onCancel();
              }
            }
          }}
          disabled={exceedsCapacity}
        >
          ✓
        </ActionButton>
        <ActionButton
          color="red"
          title="Clear"
          onClick={() => {
            // Clear the input field first
            if (inputRef.current) {
              inputRef.current.value = "";
            }
            // Then cancel editing
            onCancel();
          }}
        >
          ✕
        </ActionButton>
      </ActionButtonsContainer>
    );
  }

  // If quantity exists, show Submit button instead of Edit (when not in edit mode)
  if (hasQuantity) {
    return (
      <EditButtonCell>
        <SubmitButton
          onClick={onSubmit}
          disabled={!canSubmit || isDisabled}  // disable when submission not allowed
        >
          Submit
        </SubmitButton>
      </EditButtonCell>
    );
  }

  // Show Edit button when not in edit mode and no quantity
  return (
    <EditButtonCell>
      <EditButton
        onClick={onStartEdit}
        disabled={isDisabled}
      >
        Edit
      </EditButton>
    </EditButtonCell>
  );
};